import React, { useEffect, useMemo, useState } from "react";
import * as S from "./ContentInfo.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import * as P from "../../../../../utils/pipes";
import { useTranslation } from "react-i18next";


function ContentInfo ({
  content
}) {  

  const { i18n: { language } } = useTranslation("global");

  const normalizedTags = useMemo(() => {
      const uniqueCommentsMap = new Map();
  
      content?.mediaCards.forEach(card => {
        card.mediaCardToMediaTags.forEach(tag => {
          const comment = tag.enMediaTag.comment;
          const key = JSON.stringify(comment);
          if (!uniqueCommentsMap.has(key)) {
            uniqueCommentsMap.set(key, comment);
          }
        });
      });
  
      return Array.from(uniqueCommentsMap.values()).map(item => {
        return P.dataTranslation(item, language);
      })
  
    }, [content]);

  return (
    <S.ContentInfo>
      <div className="img-container">
        <img src={
          content?.imageUrl
            ? content.imageUrl
            : "https://blocks.astratic.com/img/general-img-portrait.png"
          // "https://img.freepik.com/foto-gratis/dia-mundial-cancer-personas-abrazadas_23-2151064696.jpg?t=st=1752243545~exp=1752247145~hmac=14e40130810e9b6cd21c4d089c29891b89d1d6e479ca94ed1cf10135dc127c16&w=826"
        } alt="content-img" className="content-img" />
      </div>
      <div className="separator"></div>
      <div className="title">
        {
          P.dataTranslation(content.name, language)
        }
      </div>
      <div className="categories">
        {
          normalizedTags.length > 0 
            ? normalizedTags.join(', ')
            : "Sin categorías"
        }
      </div>
      <div className="description">
        {
          P.dataTranslation(content.description, language)
        }
      </div>
    </S.ContentInfo>
  )

}

export default ContentInfo;
